import { Directive } from '@angular/core';

@Directive({
  selector: '[timeline-content]'
})
export class TimelineSelectorDirective {

  constructor() { }

}
